import { Plural, Trans } from '@lingui/react/macro';
import { useMemo } from 'react';

import type { AudienceOptionType } from '@/api/audience';
import { ColorBadge } from '@/components/typography';
import { AUDIENCE_PRIMARY, TAM_PRIMARY } from '@/constants/colors';

type Props = {
  audiences: AudienceOptionType[];
  isInTam: boolean;
};

const AudienceMembershipTags = ({ audiences, isInTam }: Props) => {
  const nonTAMAudiences = useMemo(
    () => audiences.filter((audience) => !audience.isTAM),
    [audiences],
  );

  return (
    <div className="flex justify-end gap-1">
      {nonTAMAudiences.length > 0 && (
        <ColorBadge size="medium" color={AUDIENCE_PRIMARY} showTooltip={false}>
          <Plural value={nonTAMAudiences.length} one="# Audience" other="# Audiences" />
        </ColorBadge>
      )}
      {isInTam && (
        <ColorBadge size="medium" color={TAM_PRIMARY} showTooltip={false}>
          <Trans>TAM</Trans>
        </ColorBadge>
      )}
    </div>
  );
};

export default AudienceMembershipTags;
